module.exports = __webpack_public_path__ + "static/media/icoOption-Default.c60f436a.svg";